import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class ConfirmModalComponent {
  @Input() title: string;
  @Input() text: string;

  modal: NgbActiveModal;

  constructor() {
    this.modal = inject(NgbActiveModal);
  }

  public confirm(): void {
    this.modal.close(true);
  }
}
